import React from 'react';
import MensagemSucesso from '../../components/shared/form/mensagens/sucesso';

const SemPermissao = () => {

  const handleClick = () => {
    window.location = '/';
  }

  return (
    <MensagemSucesso
      titulo="Para acesso aguarde aprovação."
      mensagem="Sua solicitação de acesso foi enviada. Assim que aprovada, você será notificado por e-mail sobre a liberação de acesso a plataforma."
      onClick={(handleClick)}
      hasError={true}
    />
  )
}

export default SemPermissao;
